module.exports = __webpack_public_path__ + "img/badgeCheck.9488cd20.svg";